import { createContext } from 'react';

export const ModalContext = createContext<any>(null);